import { Field, Section, TagInput, CheckboxPill } from "./_shared";

const PROPERTY_TYPES = ["hotel", "apartament", "vilë", "bujtinë", "resort"];
const PROPERTY_TYPE_VALUES = ["hotel", "apartment", "villa", "hostel", "resort"];
const AMENITIES = [
    { key: "wifi", label: "Wi-Fi" },
    { key: "parking", label: "Parking" },
    { key: "pool", label: "Pishinë" },
    { key: "breakfast", label: "Mëngjes" },
    { key: "spa", label: "Spa" },
    { key: "gym", label: "Palestër" },
    { key: "restaurant", label: "Restorant" },
    { key: "bar", label: "Bar" },
    { key: "ac", label: "Kondicioner" },
    { key: "pet_friendly", label: "Pranohen kafshë" },
    { key: "shuttle", label: "Transport" },
    { key: "ev_charging", label: "Karikim EV" },
];

export default function Step2Property({ data, update }) {
    return (
        <>
            <Section title="Të dhënat bazë të pronës">
                <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                    <Field label="Emri i pronës" required>
                        <input className="akm-input" value={data.property_name} onChange={(e) => update({ property_name: e.target.value })} placeholder="p.sh. Akomoda Tirana Center" data-testid="wizard-property-name" />
                    </Field>
                    <Field label="Lloji">
                        <select className="akm-input" value={data.property_type} onChange={(e) => update({ property_type: e.target.value })}>
                            {PROPERTY_TYPE_VALUES.map((v, i) => <option key={v} value={v}>{PROPERTY_TYPES[i]}</option>)}
                        </select>
                    </Field>
                </div>
                <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
                    <Field label="Numri i dhomave" hint="Përdoret VETËM nëse s'jepni disponueshmëri për lloj"><input type="number" min="1" className="akm-input" value={data.num_rooms} onChange={(e) => update({ num_rooms: Number(e.target.value) })} data-testid="wizard-num-rooms" /></Field>
                    <Field label="Katet"><input type="number" min="1" className="akm-input" value={data.floors} onChange={(e) => update({ floors: Number(e.target.value) })} /></Field>
                    <Field label="Kapaciteti default"><input type="number" min="1" className="akm-input" value={data.capacity_default} onChange={(e) => update({ capacity_default: Number(e.target.value) })} /></Field>
                </div>
                <Field label="Kategoritë e dhomave" hint="Përdoren si default për tipet e dhomave. Shtyp Enter për të shtuar.">
                    <TagInput value={data.room_categories} onChange={(v) => update({ room_categories: v })} placeholder="Standard, Deluxe…" />
                </Field>
                <Field label="Numrat e dhomave" hint="Opsionale · të ndara me presje (p.sh. 101,102,201). Lëre bosh për t'u gjeneruar automatikisht.">
                    <input className="akm-input" value={data.room_numbers} onChange={(e) => update({ room_numbers: e.target.value })} placeholder="101,102,103,201,202…" />
                </Field>
            </Section>

            <Section title="Pajisjet & shërbimet">
                <div className="flex flex-wrap gap-1.5">
                    {AMENITIES.map(({ key, label }) => (
                        <CheckboxPill
                            key={key}
                            checked={data.amenities.includes(key)}
                            onChange={(v) => update({ amenities: v ? [...data.amenities, key] : data.amenities.filter((x) => x !== key) })}
                            testId={`amenity-${key}`}
                        >
                            {label}
                        </CheckboxPill>
                    ))}
                </div>
            </Section>

            <Section title="Politikat">
                <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                    <Field label="Ora e check-in"><input type="time" className="akm-input" value={data.check_in_time} onChange={(e) => update({ check_in_time: e.target.value })} /></Field>
                    <Field label="Ora e check-out"><input type="time" className="akm-input" value={data.check_out_time} onChange={(e) => update({ check_out_time: e.target.value })} /></Field>
                </div>
                <Field label="Politika e anulimit">
                    <textarea className="akm-input h-20 py-2" value={data.cancellation_policy} onChange={(e) => update({ cancellation_policy: e.target.value })} placeholder="p.sh. Anulim falas deri 48 orë para check-in." />
                </Field>
                <Field label="Rregullat e shtëpisë">
                    <textarea className="akm-input h-20 py-2" value={data.house_rules} onChange={(e) => update({ house_rules: e.target.value })} placeholder="p.sh. Ndalohet duhani. Orari i qetësisë 22:00–08:00." />
                </Field>
            </Section>
        </>
    );
}
